/**
 * Hebrew localization for the Amplify Authenticator (login / reset flows).
 *
 * The rest of the SPA is authored in Hebrew directly; only the Amplify UI
 * component ships English strings, so we register a Hebrew vocabulary and
 * switch the active language. Imported for its side effects from main.tsx
 * before the app renders.
 */
import { I18n } from 'aws-amplify/utils';

I18n.putVocabularies({
  he: {
    // Sign in
    'Sign In': 'התחברות',
    'Sign in': 'התחברות',
    'Sign in to your account': 'התחברות לחשבון',
    'Signing in': 'מתחבר…',
    'Sign Out': 'התנתקות',
    Email: 'אימייל',
    Password: 'סיסמה',
    'Enter your Email': 'הזינו את האימייל שלכם',
    'Enter your Password': 'הזינו את הסיסמה שלכם',
    'Forgot your password?': 'שכחתם סיסמה?',

    // Reset password
    'Reset Password': 'איפוס סיסמה',
    'Reset your password': 'איפוס הסיסמה שלכם',
    'Reset your Password': 'איפוס הסיסמה שלכם',
    'Send code': 'שליחת קוד',
    'Send Code': 'שליחת קוד',
    'Back to Sign In': 'חזרה להתחברות',
    'Resend Code': 'שליחת קוד מחדש',
    'Code': 'קוד',
    'Confirmation Code': 'קוד אימות',
    'Enter your code': 'הזינו את הקוד',
    'Enter your Confirmation Code': 'הזינו את קוד האימות',
    'We Emailed You': 'שלחנו לכם אימייל',
    'Your code is on the way. To log in, enter the code we emailed to':
      'הקוד בדרך אליכם. כדי להתחבר, הזינו את הקוד ששלחנו לכתובת',
    'It may take a minute to arrive.': 'ייתכן שההודעה תגיע תוך דקה.',

    // New / change password
    'Change Password': 'שינוי סיסמה',
    'New Password': 'סיסמה חדשה',
    'Enter your new password': 'הזינו סיסמה חדשה',
    'Confirm Password': 'אימות סיסמה',
    'Please confirm your Password': 'אנא אשרו את הסיסמה',
    'Confirm': 'אישור',
    'Submit': 'שליחה',
    'Change': 'שינוי',

    // Common validation / status messages
    'Your passwords must match': 'הסיסמאות חייבות להיות זהות',
    'Password did not conform with policy: Password not long enough':
      'הסיסמה קצרה מדי',
    'Incorrect username or password.': 'אימייל או סיסמה שגויים.',
    'User does not exist.': 'המשתמש אינו קיים.',
    'Username cannot be empty': 'יש להזין אימייל',
    'Password cannot be empty': 'יש להזין סיסמה',
    'Network error': 'שגיאת רשת',
    'An account with the given email already exists.':
      'קיים כבר חשבון עם כתובת אימייל זו.',
    'Attempt limit exceeded, please try after some time.':
      'חרגתם ממספר הניסיונות המותר, נסו שוב מאוחר יותר.',
  },
});

I18n.setLanguage('he');
